import { createAppRequest } from '@/services/request';

const request = createAppRequest();
const base = '/bff/cms/category';

export interface ContentCategory {
  uuid: string;
  siteUuid: string;
  name: string;
  parentUuid: string | null;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}
export interface CategoryListResult { data: ContentCategory[]; total: number; page: number; limit: number; totalPages: number; }
export const categoryManagementApi = {
  list: (params: { page?: number; limit?: number; siteUuid?: string; keyword?: string }) => request<CategoryListResult>(base, { method: 'GET', params }),
  options: (siteUuid: string) => request<ContentCategory[]>(`${base}/options`, { params: { siteUuid } }),
  create: (data: { siteUuid: string; name: string; parentUuid?: string; sortOrder?: number }) => request<ContentCategory>(base, { method: 'POST', data }),
  update: (uuid: string, data: { name: string; parentUuid?: string | null; sortOrder?: number }) => request<ContentCategory>(`${base}/${uuid}`, { method: 'PATCH', data }),
  remove: (uuid: string) => request<void>(`${base}/${uuid}`, { method: 'DELETE' }),
};
